import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { isAssessmentStudent } from './assessmentStudent';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();
  const { user, loading } = useUser();

  if (!token) {
    // Save the intended URL so Login can redirect back after authentication
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?redirectTo=${redirectTo}`} replace />;
  }
   // Students may only use assessment + test execution routes
   if (!loading && isAssessmentStudent(user)) {
    const path = location.pathname;
    const allowed =
      path === '/assessment' ||
      path.startsWith('/assessment/') ||
      path.startsWith('/execution/');
    if (!allowed) {
      return <Navigate to="/assessment" replace />;
    }
  }

  return children;
}

export default PrivateRoute;
